const items = [
  {
    title: "Story-Driven Approach",
    info: "Every project starts with a strong narrative. We dive deep into your brand or idea to uncover its core message, ensuring that the final product resonates with authenticity and emotional impact.",
  },
  {
    title: "Collaboration at Heart",
    info: "We believe the best results happen when we combine our expertise with your vision. By fostering open communication at every step, we build a partnership that’s focused on achieving the best possible outcome for your project.",
  },
  {
    title: "Commitment to Quality",
    info: "From lighting and sound to post-production and final review, we obsess over the details. Our meticulous standards allow us to maintain the highest level of quality in everything we do.",
  },
];

export function AboutUs() {
  return (
    <div className="bg-gradient-to-b from-slate-100 to-royalBlue">
      {/* HERO */}
      <section className="mx-auto max-w-7xl px-6 lg:px-8 py-20 ">
        <div className="mx-auto max-w-xl rounded-2xl bg-white/70 backdrop-blur p-4 shadow-sm ring-1 ring-black/5  mt-20">
          <div className="text-center">
            <p className="text-2xl font-semibold tracking-wide text-blue-700">
              At GCM Productions
            </p>
            <h1 className="mt-3 text-pretty text-2xl font-bold tracking-tight text-gray-900 sm:text-3xl">
              We handle every stage of production
            </h1>

            <div className="mt-8 flex items-center justify-center gap-4">
              <a
                href="#contact"
                className="inline-flex items-center rounded-xl px-5 py-3 text-base font-semibold bg-blue-700 hover:bg-blue-500  text-white shadow-sm  focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
              >
                Get in touch
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* PORTRAITS + LOGO (Welcoming intro) */}
      <section className="mx-auto max-w-6xl px-6 lg:px-8 pb-16">
        <div className="grid grid-cols-1 sm:grid-cols-3 items-center justify-items-center gap-10">
          <figure className="flex flex-col items-center text-center">
            <img
              src="../Imgs/AboutUsPics/Christopher Hernandez.JPG"
              alt=""
              className="h-[280px] w-auto rounded-2xl shadow-sm object-cover"
            />
            <figcaption className="mt-3 text-sm font-medium text-white">
              Christopher Hernandez
            </figcaption>
            <figcaption className="mt-3 text-sm  font-semibold italic text-white">
              CO-OWNER & PRODUCER
            </figcaption>
          </figure>

          <div className="flex flex-col items-center">
            <img
              src="../Imgs/GCM LOGO.png"
              alt=""
              className="h-[180px] w-auto drop-shadow-sm"
            />
            <p className="mt-4 max-w-xs text-center text-white text-md font-extrabold">
              “Crafting unforgettable stories through film, sound, and design.”
            </p>
          </div>

          <figure className="flex flex-col items-center text-center">
            <img
              src="../Imgs/AboutUsPics/Maria Alejandra Hernandez.JPG"
              alt=""
              className="h-[280px] w-auto rounded-2xl shadow-sm object-cover"
            />
            <figcaption className="mt-3 text-sm text-white font-semibold">
              Maria Alejandra Hernandez
            </figcaption>
            <figcaption className="mt-3 text-sm text-white font-semibold italic">
              CO-OWNER & CREATIVE DIRECTOR
            </figcaption>
          </figure>
        </div>
      </section>

      {/* ABOUT COPY */}
      <section className="bg-gradient-to-a from-slate-100 to-royalBlue">
        <div className="mx-auto max-w-4xl px-6 lg:px-8 py-10">
          <h2 className="text-center text-pretty text-4xl font-semibold tracking-tight text-white sm:text-5xl">
            About Us
          </h2>
          <p className="mt-6 text-xl leading-8 text-white">
            We started GCM Productions from a shared love of creation. Our
            passion for films brought us together, and it’s what continues to
            drive us every day. We believe that storytelling through moving
            images is one of the most powerful ways to connect, inspire, and
            move people.
          </p>
          <h4 className="text-2xl font-bold text-white pt-4">
            {" "}
            What makes GCM Productions special:{" "}
          </h4>
          <p className="mt-4 text-xl leading-8 text-white">
            A shared passion for film and storytelling that informs our approach
            to every project. A collaborative mindset rooted in listening
            first—understanding your vision, your audience, and your goals. We
            bring our love for this work with us on every project and humbly
            listen to our clients' needs, transforming ideas into authentic,
            compelling visuals. Let’s tell your story together. Reach out to
            start a conversation about your next project.
          </p>

          {/* Philosophy list */}
          {/* <div className="mt-10 mx-auto max-w-2xl">
            <h3 className="text-2xl font-bold text-white">A little about us</h3>
            <ol className="mt-6 space-y-6">
              {items.map((item, idx) => (
                <li key={idx} className="flex items-start gap-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth={1.5}
                    stroke="currentColor"
                    className="size-6 text-black"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="m15.75 10.5 4.72-4.72a.75.75 0 0 1 1.28.53v11.38a.75.75 0 0 1-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25h-9A2.25 2.25 0 0 0 2.25 7.5v9a2.25 2.25 0 0 0 2.25 2.25Z"
                    />
                  </svg>

                  <div>
                    <h4 className="font-semibold text-white">{item.title}</h4>
                    <p className="mt-1 text-white">{item.info}</p>
                  </div>
                </li>
              ))}
            </ol>
          </div> */}
        </div>
      </section>

      {/* CTA BANNER */}
      <section id="contact" className="px-6 lg:px-8 py-20">
        <div className="mx-auto max-w-4xl rounded-2xl bg-gray-300 px-8 py-10 text-center text-black shadow-sm y-20">
          <h3 className="text-4xl font-bold tracking-tight">Ready to roll?</h3>
          <p className="mt-2 text-black text-lg">
            Tell us about your project and we’ll help you bring it to life.
          </p>
          <div className="mt-6 flex items-center justify-center gap-4">
            <a
              href="mailto:GCMProductionsny@gmail.com"
              className="inline-flex bg-blue-600 items-center rounded-xl border border-white/80 px-5 py-3 text-base font-semibold text-white hover:bg-white/10"
            >
              Email us
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
